import { E_ColoriTessuto } from "../../components/Utils/enumerations";

export const CodiciColoreOmbrelloni = [
    {
        label: E_ColoriTessuto.T5,
        value: "#145b42",   
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T5.png`
    },
    {
        label: E_ColoriTessuto.T12_15,
        value: "#f8bd4f",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T12_15.png`
    },
    {
        label: E_ColoriTessuto.T14,
        value: "#c2aa8a",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T14.png`
    },
    {
        label: E_ColoriTessuto.T15,
        value: "#f5f5f5",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T15.png`
    },
    {
        label: E_ColoriTessuto.T15_93,
        value: "#fcf3e6",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T15_93.png`
    },
    {
        label: E_ColoriTessuto.T24,
        value: "#0e0c0e",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T24.png`
    },
    {
        label: E_ColoriTessuto.T73,
        value: "#721c2f",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T73.png`
    },
    {
        label: E_ColoriTessuto.T79,
        value: "#cac6c4",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T79.png`
    },
    {
        label: E_ColoriTessuto.T81,
        value: "#1e1319",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T81.png`
    },
    {
        label: E_ColoriTessuto.T92,
        value: "#1b142a",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T92.png`
    },
    {
        label: E_ColoriTessuto.T93_15,
        value: "#eee3c0",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T93_15.png`
    },
    {
        label: E_ColoriTessuto.T97_15,
        value: "#454c4a",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T97_15.png`
    },
    {
        label: E_ColoriTessuto.T106,
        value: "#b8a087",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T106.png`
    },
    {
        label: E_ColoriTessuto.T151_15,
        value: "#e3dac0",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T151_15.png`
    },
    {
        label: E_ColoriTessuto.T426,
        value: "#b44131",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T426.png`
    },
    {
        label: E_ColoriTessuto.T926,
        value: "#79695e",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T926.png`
    },
    {
        label: E_ColoriTessuto.T986_727,
        value: "#e1e1e1",
        texture: `${process.env.PUBLIC_URL}/textures/ombrelloni/FabricTexturesOmbrelloni/T986_727.png`
    },    
]; 